import React, { useState, useEffect, useCallback } from 'react';
import api from '../api';

// A site's pending prompt suggestions: edit, then approve into the prompt set
// or dismiss. Used on the site's own page and on the cross-site board.
export default function GeoSuggestions({ siteId, onChanged }) {
  const [items, setItems] = useState(null);
  const [checked, setChecked] = useState({});
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const show = useCallback(list => {
    setItems(list.map(s => ({ id: s.id, prompt: s.prompt, search_query: s.search_query || '' })));
    setChecked(Object.fromEntries(list.map(s => [s.id, true])));
  }, []);

  useEffect(() => {
    api.getGeoSuggestions(siteId).then(res => show(res.suggestions || [])).catch(err => setError(err.message));
  }, [siteId, show]);

  if (error && !items) return <div style={{ fontSize: 12, color: 'var(--red)' }}>{error}</div>;
  if (!items) return <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>טוען...</div>;
  if (!items.length) return null;

  const chosen = items.filter(s => checked[s.id]);

  async function act(fn) {
    setBusy(true);
    setError(null);
    try {
      const res = await fn();
      show(res.suggestions || []);
      if (onChanged) onChanged();
    } catch (err) { setError(err.message); }
    setBusy(false);
  }

  function edit(id, field, value) {
    setItems(items.map(s => (s.id === id ? { ...s, [field]: value } : s)));
  }

  return (
    <div>
      <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 4 }}>הצעות ממתינות לאישור ({items.length})</div>
      <div style={{ fontSize: 12, color: 'var(--text-secondary)', marginBottom: 10 }}>
        אפשר לערוך לפני האישור. אישור מוסיף את הפרומפטים לסט; הוא לא מפעיל את המדידה.
      </div>
      {error && <div style={{ fontSize: 12, color: 'var(--red)', marginBottom: 8 }}>{error}</div>}
      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, marginBottom: 10 }}>
        <tbody>
          {items.map(s => (
            <tr key={s.id} style={{ borderTop: '1px solid var(--border)' }}>
              <td style={{ padding: '6px 4px', width: 28 }}>
                <input type="checkbox" checked={!!checked[s.id]} style={{ accentColor: 'var(--accent)' }}
                  onChange={e => setChecked({ ...checked, [s.id]: e.target.checked })} />
              </td>
              <td style={{ padding: '6px 4px' }}>
                <input className="geo-input" value={s.prompt} maxLength={500} style={{ width: '100%' }}
                  onChange={e => edit(s.id, 'prompt', e.target.value)} />
              </td>
              <td style={{ padding: '6px 4px', width: 220 }}>
                <input className="geo-input" value={s.search_query} placeholder="ביטוי חיפוש ל-AIO" style={{ width: '100%' }}
                  onChange={e => edit(s.id, 'search_query', e.target.value)} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ display: 'flex', gap: 8 }}>
        <button className="btn btn-primary" disabled={busy || !chosen.length}
          onClick={() => act(() => api.approveGeoSuggestions(siteId, chosen))}>אישור {chosen.length} מסומנים</button>
        <button className="btn btn-secondary" disabled={busy || !chosen.length}
          onClick={() => act(() => api.dismissGeoSuggestions(siteId, chosen.map(s => s.id)))}>דחיית המסומנים</button>
      </div>
    </div>
  );
}
